import { Component, Input } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { CellClickEvent } from '@progress/kendo-angular-grid';
import { FeatureFlagService } from '@app/cp/shared/services/feature-flag.service';

@Component({
    selector: 'cp-order-search-results',
    templateUrl: './order-search-results.component.html',
    styleUrls: ['./order-search-results.component.scss'],
    standalone: false
})
export class OrderSearchResultsComponent {
  SearchTarget: SearchTarget;
  @Input() searchFilter: string;
  @Input() loading: boolean = false;
  @Input() resultsData: any;
  @Input() searchTarget: SearchTarget = SearchTarget.order;
    @Input() isZuggitUser: boolean = false;
  @Output() cellClickEvent = new EventEmitter<CellClickEvent>();
  @Output() closeSearchResultsEvent = new EventEmitter<null>();

  featureFlagSet: any = {};
  skip: number = 0;
  constructor(protected featureFlagService: FeatureFlagService) {
    this.featureFlagService.featureFlagSets.subscribe(data => {
        this.featureFlagSet = data;
    });
}

  cellClick(dataItem: CellClickEvent) {
    this.cellClickEvent.emit(dataItem);
  }
  onCloseSearchResults() {
    this.closeSearchResultsEvent.emit(null);
  }
}